import { FormikProps, useFormik } from 'formik';
import { getAddTrainingActivityTypeFormValidation } from './FormikData';
import { useTranslation } from 'react-i18next';
import { ITrainingActivityType } from '../../../../types/interfaces/training-activity-type';
import { FormikValues } from 'formik/dist/types';
import { usePostPutTrainingActivityType } from '../../../../services/redux/api/trainingActivityTypesApi';

export function useAddTrainingActivityTypeComponent(
  onClose: () => void,
  trainingActivityType?: ITrainingActivityType,
) {
  const { t } = useTranslation();
  const isEdit = !!trainingActivityType?.id;
  const [postPutTrainingActivityType, { isLoading }] =
    usePostPutTrainingActivityType();

  const formik: FormikProps<any> = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: getAddTrainingActivityTypeFormValidation(t),
    initialValues: {
      nameKey: trainingActivityType?.nameKey || '',
      met: trainingActivityType?.met ?? '',
      isDefault: trainingActivityType?.isDefault ?? false,
    },
    onSubmit: onSubmit,
  });

  function onSubmit(values: FormikValues) {
    const met = Number(values.met);
    const body = isEdit
      ? {
          nameKey: values.nameKey,
          met,
          isDefault: values.isDefault,
        }
      : {
          id: values.nameKey,
          nameKey: values.nameKey,
          met,
          isDefault: values.isDefault,
        };

    postPutTrainingActivityType({
      id: isEdit ? trainingActivityType.id : undefined,
      body,
    })
      .unwrap()
      .then(() => {
        onClose();
      })
      .catch((error: any) => {
        if (error?.status === 400) {
          const originalErrorMessage = (
            error?.message ||
            error?.data?.message ||
            ''
          ).trim();
          const errorMessageLower = originalErrorMessage.toLowerCase();

          if (
            errorMessageLower.includes('namekey') ||
            errorMessageLower.includes('name key') ||
            errorMessageLower.includes('id') ||
            errorMessageLower.includes('duplicate')
          ) {
            formik.setFieldTouched('nameKey', true, false);
            formik.setFieldError('nameKey', originalErrorMessage);
          } else if (errorMessageLower.includes('met')) {
            formik.setFieldTouched('met', true, false);
            formik.setFieldError('met', originalErrorMessage);
          }
        }
      });
  }

  return { formik, isLoading };
}
